import * as React from 'react';

function SvgDirect(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={552.611}
      height={552.611}
      {...props}
    >
      <path d="M486.413 221.412L122.347 12.916c-52.938-30.318-95.852-5.44-95.852 55.563v415.652c0 61.004 42.914 85.882 95.852 55.563l364.066-208.49c52.938-30.317 52.938-79.473 0-109.792z" />
    </svg>
  );
}

export default SvgDirect;
